import { initializeApp } from "firebase/app";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDGomaSPFdQ717-hWqetNU5tIwbmHshvZw",
  authDomain: "epromaster-e8f7f.firebaseapp.com",
  projectId: "epromaster-e8f7f",
  storageBucket: "epromaster-e8f7f.firebasestorage.app",
  messagingSenderId: "414795309798",
  appId: "1:414795309798:web:f23643ba87d3144f311127",
  measurementId: "G-ESZYMHZJYE"
};

export const app = initializeApp(firebaseConfig);


